var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2d7daada3d913152e31c9d6f15818b06.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7f8ce130b98033cc71e48a27287b3dd9.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/80793c0334763f3a28d6307320e1a6e8.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95afc7e3ece9fb4d4bcf6cede4a0d2c2.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    